import { createTranslations } from '@npco/common-utils-translations'

export const nicknameFieldTranslations = createTranslations({
  label: 'Nickname (eg. Office Power Bill)',
  errorRequired: 'Nickname is required.',
  toolTipLabel: 'Tooltip for Nickname',
  toolTipText:
    'Group your Biller Code & CRN with a Nickname for easier selection in the future.',
})
